import * as React from "react";
import {Paper, Table, TableBody, TableContainer} from "@mui/material";
import GatewayRow from "./GatewayRow";
import FormattedTableHead from "../FormattedTableHead";
import {ThreeDots} from "@dvrt/graphql-widgets";
import {useDomainGatewayStatusQuery} from "./queries.generated";
import {defineMessage} from "react-intl";

type Props = {
    domainId: number;
};

export default ({domainId}: Props) => {
    const {data} = useDomainGatewayStatusQuery({
        variables: {domainId},
        fetchPolicy: "cache-and-network",
    });

    if (!data) return <ThreeDots height={5} />;

    function createRows(): React.ReactNode[] {
        const rows = [];
        let i = 0;
        for (const gateway of data.domainStatus.gateways) {
            rows.push(<GatewayRow key={i} domainId={domainId} gateway={gateway} />);
            i++;
        }

        return rows;
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <FormattedTableHead
                    cells={[
                        {label: defineMessage({id: "number", defaultMessage: "Number"})},
                        {label: defineMessage({id: "name", defaultMessage: "Name"})},
                        {label: defineMessage({id: "ip_address", defaultMessage: "IP address"})},
                        {
                            label: defineMessage({
                                id: "last_registration_time",
                                defaultMessage: "Last registration time",
                            }),
                        },
                    ]}
                />
                <TableBody>{createRows()}</TableBody>
            </Table>
        </TableContainer>
    );
};
